import Theme from '@jetbrains/ring-ui-built/components/global/theme'

import type {State} from '../reducers/types'
import {UserProperties} from '../utils/userProperties'

import {getUserProperty} from '.'

export const getCurrentTheme = (state: State): Theme => {
  const stateTheme = getUserProperty(state, UserProperties.THEME) as Theme | null | undefined

  return stateTheme ?? Theme.AUTO
}
